<template>
    <div class="form-group">
        <slot name="label">
            <label v-if="label">{{ label }} {{ required ? '*' : '' }}</label>
        </slot>
        <slot>
            <template v-if="$attrs.mask && $attrs.mask.length > 0">
                <the-mask :value="value" v-on="listeners" ref="maskedInput" v-bind="$attrs" :class="{'form-control': !plainText, 'form-control-plaintext': plainText, 'is-invalid': error ? true : false}" />
            </template>
            <template v-else-if="isMoney">
                <money :value="value" v-money="money" v-on="listeners" v-bind="$attrs" :class="{'form-control': !plainText, 'form-control-plaintext': plainText, 'is-invalid': error ? true : false}" />
            </template>
            <template v-else>
                <input :value="value" v-on="listeners" v-bind="$attrs" :class="{'form-control': !plainText, 'form-control-plaintext': plainText, 'is-invalid': error ? true : false}" />
            </template>
        </slot>
        <slot name="error" v-if="error || $slots.error">
            <div class="invalid-feedback">
                {{ error }}
            </div>
        </slot>
        
    </div>
</template>
<script>
export default {
    inheritAttrs: false,
    name: 'base-input',
    props: {
        label: {
            type: String
        },
        required: {
            type: Boolean
        },
        isMoney: {
            type: Boolean,
            default: false
        },
        error: {
            type: String,
            description: 'Input error',
            default: ''
        },
        value: {
            type: [String, Number],
            description: 'Input value'
        },
        prefix: {
            type: String,
            default: 'R$ '
        },
        plainText: {
            type: Boolean,
            default: false
        }
    },
    model: {
        prop: 'value',
        event: 'input'
    },
    data() {
        return {
            focused: false,
            touched: false,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: this.prefix,
                suffix: '',
                precision: 2,
                masked: false
            }
        }
    },
    computed: {
        listeners() {
            return {
                ...this.$listeners,
                input: this.onInput,
                blur: this.onBlur,
                focus: this.onFocus
            }
        }
    },
    methods: {
        onInput(evt) {
            if (!this.touched) {
                this.touched = true
            }
            this.$emit('input', evt.target ? evt.target.value : evt)
        },
        onFocus() {
            this.focused = true
        },
        onBlur() {
            this.focused = false
        },
        clearValue() {
            if (this.$refs.maskedInput) {
                this.$refs.maskedInput.$data.lastValue = null
            }
        }
    }
}
</script>
